import { addBusinessDays } from 'date-fns';

const N_BUSINESS_DAYS_TO_SKIP = 3;

const prevBindFn = () => addBusinessDays(new Date(), N_BUSINESS_DAYS_TO_SKIP);

export default (props, vars) =>
  typeof prevBindFn === 'function' ? prevBindFn() : prevBindFn;
